export default [{
  path: 'ordernew/:leftid',
  name: 'merchant_ordernew',
  component: () => import('@/views/merchant/admin/order/new'),
  meta: {
    tpflag: 'merchant',
    title: '新增订单',
  }
}, {
  path: 'orderstatus/:leftid',
  name: 'merchant_orderstatus',
  component: () => import('@/views/merchant/admin/order/status'),
  meta: {
    tpflag: 'merchant',
    title: '订单状态',
  }
}, {
  path: 'orderconfig/:leftid',
  name: 'merchant_orderconfig',
  component: () => import('@/views/merchant/admin/order/list'),
  meta: {
    tpflag: 'merchant',
    title: '我的订单',
  }
}, {
  path: 'orderdetail/:leftid',
  name: 'merchant_orderdetail',
  component: () => import('@/views/merchant/admin/order/detail'),
  meta: {
    tpflag: 'merchant',
    title: '订单详情',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_order.js